import React from 'react';
import { css } from 'emotion';
export const MaintainAspectRatio = ({ height, width, children }) => (
/* https://css-tricks.com/aspect-ratio-boxes/ */
React.createElement("div", { className: css `
			/* position relative to contain the absolutely positioned iframe plus any Overlay image */
			position: relative;
			padding-bottom: ${(height / width) * 100}%;

			iframe {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}
		` }, children));
